import { Component } from '@angular/core';
import {Router} from "@angular/router";
import {UserService} from "../../services/user.service";

@Component({
	selector: 'users',
	templateUrl: 'users.html'
})

export class UsersComponent{
    constructor(
        private userService: UserService,
        public router: Router
    ) { };

    accountRole = this.userService.accountRole;
}



// WEBPACK FOOTER //
// ./src/app/components/users/users.component.ts